import { Grid } from '@mui/material';
import FlightIcon from '@mui/icons-material/Flight';
import RoomServiceIcon from '@mui/icons-material/RoomService';
import PublicIcon from '@mui/icons-material/Public';
import WorkIcon from '@mui/icons-material/Work';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CachedIcon from '@mui/icons-material/Cached';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import HotelIcon from '@mui/icons-material/Hotel';
import StarIcon from '@mui/icons-material/Star';

const ICONS_MAP = {
  airplanemode_active: {
    component: FlightIcon,
    sx: { transform: 'rotate(90deg)' },
  },
  room_service: { component: RoomServiceIcon },
  public: { component: PublicIcon },
  work: { component: WorkIcon },
  directions_bus: { component: DirectionsBusIcon },
  directions_boat: { component: DirectionsBoatIcon },
  add_box: { component: AddBoxIcon },
  cached: { component: CachedIcon },
  flight: { component: SyncAltIcon },
  hotel: { component: HotelIcon },
  star: { component: StarIcon },
};

const PlateIcons = ({ icon }) => {
  const iconData = ICONS_MAP[icon];
  if (!iconData) return null;

  const { component: IconComponent } = iconData;

  return (
    <Grid
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 0.5,
      }}
    >
      <IconComponent />
    </Grid>
  );
};

export default PlateIcons;
